import { DecimalPipe, TitleCasePipe } from "@angular/common";
import { Component, effect, input, InputSignal } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { Exposure, ReportProcess } from "../../../../api/api.model";
import { InfoComponent } from "../../info/info.component";
import { ReportStatusComponent } from "../../report-status/report-status.component";
import { MatExpansionModule } from '@angular/material/expansion';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { AmlCategoryTransformToRiskPipe } from "../../../pipes/aml-category-transform-to-risk.pipe";

@Component({
  selector: 'app-report-exposures',
  standalone: true,
  imports: [
    MatExpansionModule,
    TranslateModule,
    MatIconModule,
    AmlCategoryTransformToRiskPipe,
    CdkAccordionModule,
    DecimalPipe,
    MatTooltipModule,
    InfoComponent,
    ReportStatusComponent,
    TitleCasePipe
  ],
  templateUrl: './report-exposures.component.html',
  styleUrl: './report-exposures.component.scss'
})
export class ReportExposuresComponent {
  exposures: InputSignal<Exposure[]> = input.required();
  typeReport: InputSignal<ReportProcess> = input.required();

  public get typeReportKey(): string {
    switch (this.typeReport()) {
      case 'FIRST_REPORT':
        return 'first_report';
      case 'TOP_10':
        return 'top_10';
      case 'SUSPISIOUS_WALLET':
        return 'problem_wallets';
      default: {
        throw new Error("Not found type report");
      }
    }
  }

  constructor() {
    effect(() => {
      const exposures = this.exposures();
      exposures?.forEach((exposure) => this._sumExposures += exposure.value);
    }, { allowSignalWrites: true });
  }

  private _sumExposures: number = 0;

  public calcPercentForExposures(value: number): number {
    return Math.round((value / this._sumExposures) * 100 * 100) / 100;
  }
}
